import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Button } from '../components/ui/Button.jsx';
import { useTranslation } from '../i18n/useTranslation.js';

import { useAuth } from './useAuth.js';

export function LoginPage() {
  const { signIn, isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  if (isAuthenticated) {
    const next = location.state?.from || '/';
    return <Navigate to={next} replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err?.message || t('login.failed'));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="brand">
          <span className="brand-mark" aria-hidden="true" />
          <span>RSZ ERP</span>
        </div>
        <h1>{t('login.title')}</h1>
        <p className="muted">{t('login.hint')}</p>

        <label className="field">
          <span className="field-label">{t('common.email')}</span>
          <input
            className="input"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="field">
          <span className="field-label">{t('common.password')}</span>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        {error && <div className="alert danger">{error}</div>}

        <Button type="submit" variant="primary" disabled={submitting}>
          {submitting ? t('login.cta.loading') : t('login.cta')}
        </Button>
        <p className="muted text-xs" style={{ textAlign: 'center' }}>
          {t('login.askAdmin')}
        </p>
      </form>
    </div>
  );
}
